import cornerstone from 'cornerstone-core';
import { discoverCTPETPairs } from './suvDiscovery';
import { computePetVoxelVolumeMm3 } from './petVoxelVolume';
import { assertSameFrameOfReference } from './suvGating';
import { makeSuvKey, setSuvStats, makeNeStats } from './suvStore';
import {
  deleteSuvSamples,
} from './suvSampleCache';
import {computeAndStoreRoiSuv} from './computeAndStoreRoiSuv'

const PRELOAD_BATCH = 8;

async function preloadPetSlices(petImageIds) {
  for (let i = 0; i < petImageIds.length; i += PRELOAD_BATCH) {
    const batch = petImageIds.slice(i, i + PRELOAD_BATCH);
    await Promise.all(
      batch.map(id =>
        cornerstone.loadAndCacheImage(id).catch(err => {
          console.warn('[SUV] PET preload failed', id.slice(-30), err);
          return null;
        })
      )
    );
  }
}

async function computeAllRoiSuvForPair({ pair, getStructureSet }) {
  const { structureSetUID, ctSeriesUID, ctImageIds, petImageIds } = pair;

  const rois = getStructureSet(structureSetUID)?.ROIContours || [];
  if (!rois.length) return;

  const forCheck = assertSameFrameOfReference(ctImageIds[0], petImageIds[0]);
  if (!forCheck.ok) {
    console.error('[SUV] FrameOfReferenceUID mismatch — marking ROIs NE', forCheck);
    for (const roi of rois) {
      const key = makeSuvKey(structureSetUID, roi.ROINumber, ctSeriesUID);
      deleteSuvSamples(key);
      setSuvStats(key, makeNeStats('for-mismatch'));
    }
    return;
  }

  const petVoxelVolumeMm3 = computePetVoxelVolumeMm3(petImageIds);
  await preloadPetSlices(petImageIds);

  for (const roi of rois) {
    await computeAndStoreRoiSuv({
      structureSetUID, ctSeriesUID, ctImageIds, petImageIds, roi, petVoxelVolumeMm3,
    });
  }
}

export default async function computeAllRoiSuv({ imageSets, getStructureSet }) {
  const pairs = discoverCTPETPairs(imageSets);
  if (!pairs.length) {
    return;
  }
  for (const pair of pairs) {
    await computeAllRoiSuvForPair({ pair, getStructureSet });
  }
}